"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const Card_1 = require("@dialogexe/cw-component-card/Card");
const LandScapeCard_1 = require("@dialogexe/cw-component-landscape-card/LandScapeCard");
class SearchResults extends React.Component {
    render() {
        const { results, total, keyword } = this.props;
        const hasFilms = results.arrangements.films && results.arrangements.films.length > 0;
        const hasCulturalEvents = results.arrangements.culture && results.arrangements.culture.length > 0;
        return (React.createElement("div", { className: "SearchResults" },
            (hasFilms || hasCulturalEvents) && (React.createElement("div", { className: "result-container" },
                React.createElement("div", { className: "results" },
                    hasFilms &&
                        React.createElement("div", null,
                            React.createElement("div", { className: "row" },
                                React.createElement("h1", null, "Kino")),
                            React.createElement("div", { className: "row is-spaced" }, results.arrangements.films.map((item, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6" },
                                React.createElement(Card_1.Card, { image: item.filmImage, title: item.filmTitle, link: item.filmLink, subtitle: null })))))),
                    hasCulturalEvents &&
                        React.createElement("div", null,
                            React.createElement("div", { className: "row" },
                                React.createElement("h1", null, "Kultur")),
                            React.createElement("div", { className: "events" }, results.arrangements.culture.map((item, index) => (React.createElement(LandScapeCard_1.default, { key: index, image: item.cultureImage, title: item.cultureTitle, link: item.cultureLink, tickets: results.tickets.filter(ticket => ticket.title === item.cultureTitle || ticket.id === item.id), description: "", features: null })))))))),
            results.news.length > 0 && (React.createElement("div", { className: "result-container" },
                React.createElement("h1", { className: "title" }, "Nyheter"),
                React.createElement("div", { className: "results" },
                    React.createElement("div", { className: "row is-spaced" }, results.news.map((item, index) => (React.createElement("div", { key: index, className: "column is-lg-3 id-md-4 is-xs-6" },
                        React.createElement(Card_1.Card, { image: item.image, title: item.title, link: item.link, subtitle: null })))))))),
            keyword !== '' && total === 0 && (React.createElement("div", { className: "level is-center" },
                React.createElement("h3", null, "Ingen treff")))));
    }
}
exports.SearchResults = SearchResults;
exports.default = react_redux_1.connect((state) => ({
    keyword: state.search.keyword,
    results: state.search.results,
    total: state.search.total,
}), null)(SearchResults);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-search-results/SearchResults.tsx